import { HttpClient } from '@angular/common/http';
import { Component, Renderer, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../_services';
import { NgxSpinnerService } from 'ngx-spinner';
import { first } from 'rxjs/operators';
import { Globals } from '../_helpers';
import { SweetAlertOptions } from 'sweetalert2';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-text-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {
  @ViewChild('closeBtn') closeBtn: ElementRef;
  public alertOption: SweetAlertOptions = {};
  oldpasswordFormControl = new FormControl('', [Validators.required,]);
  newpasswordFormControl = new FormControl('', [Validators.required,]);
  reenternewpassFormControl = new FormControl('', [Validators.required,]); 
  usernameFormControl = new FormControl('', [Validators.required,]); 

  title = 'Pareekshn';
  loading = false;
  submitted = false;
  isErrorLogin = false;
  errorMsg: string;
  returnUrl: string;
  userinfo = {};
  studentName: string = '';
  studentid: number = 0;
  usertoken: string;
  isErrorUsername: boolean; 
  show: boolean = false;
  show2: boolean = false;
  show1: boolean = false;
  isSuccess = false;
  succMsg: string;
  profilepic: string = '';
  
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private http: HttpClient,
    private globals: Globals,
    private spinner: NgxSpinnerService,   
) { }


  ngOnInit() {
    
    this.userinfo = JSON.parse(localStorage.getItem('userinfo_ps')); 
    this.studentName = this.userinfo['name']; 
    this.usertoken = this.userinfo['usertoken']; 
    this.studentid = this.userinfo['student_id'];
    this.profilepic = this.userinfo['profile_pic'];
    if(this.profilepic == '')
    {
      this.profilepic = '/assets/images/user.png';
    }
    this.myProfile();   
  }

  logout(){    
    localStorage.clear();
    sessionStorage.clear();
    localStorage.removeItem('userinfo_ps');
    this.authenticationService.logout();
    //this.router.navigate(['/user-login']);    
  }

studentdetails: any = [];
dob;
birthdate;
bdate;
df;
myProfile() {
    this.authenticationService.studentprofile(this.globals.root_url, this.studentid, this.usertoken)
      .pipe(first())
      .subscribe(
        data => {
          //this.spinner.hide();
          if (data.code == 1000) {
            this.studentdetails = data.profile;
            this.dob = this.studentdetails.date_of_birth;
            this.bdate = this.dob.split("T"); 
            //this.birthdate = this.bdate[0];
            var d = new Date(this.bdate);
            this.df = this.formatDate(d);  
            this.birthdate = this.df;        
          }
          else {
            this.isErrorUsername = true;
            this.errorMsg = data.status;
            this.loading = false;
          }
          this.spinner.hide();
        },
        error => {
          //this.isErrorUsername = true;
          this.errorMsg = 'Invalid Data !!';
          //this.alertService.error(error);
          this.loading = false;
          this.spinner.hide();
        }
      );
  }  
  keys : any;
  onSubmit() {
      this.submitted = true;
      /* stop here if form is invalid */
      if (this.oldpasswordFormControl.value == '' || this.newpasswordFormControl.value == '' || this.reenternewpassFormControl.value == '') {
          this.isErrorLogin = false;
          return false;
      }
      if ( this.newpasswordFormControl.value != this.reenternewpassFormControl.value) {
          this.isErrorLogin = true;
          this.reenternewpassFormControl.reset('');
          this.errorMsg = "The password and confirmation password should be same.";
          return false;
      }       
      else {
          this.loading = true;
          this.spinner.show(); //console.log(this.usertoken)
          this.authenticationService.changePassword(this.globals.root_url, this.studentid, this.oldpasswordFormControl.value, this.newpasswordFormControl.value, this.usertoken)
              .pipe(first())
              .subscribe(
                  data => {
                      if (data.code == 1000) {
                          this.isErrorLogin = false;  
                          this.isSuccess = true;  
                          this.loading = false;
                          this.spinner.hide();  
                          this.oldpasswordFormControl.reset('');
                          this.newpasswordFormControl.reset('');
                          this.reenternewpassFormControl.reset('');   
                          this.succMsg = "Password has been changed succesfully. !!";                                           
                          let that = this;
                          that.keys = setInterval(() => {
                            if(that.isSuccess == true)
                            {
                              clearInterval( that.keys ); 
                              that.closeModal();                    
                            }
                          }, 2000); 
                      }
                      else {
                          this.isErrorLogin = true;
                          this.errorMsg = data.status;
                          this.loading = false;
                      }
                      this.spinner.hide();
                  },
                  error => {
                      this.isErrorLogin = true;
                      this.errorMsg = 'Invalid Change Password !!';


                  }
              );
      }
  } 
  closeModal() {
      this.closeBtn.nativeElement.click();
  }
  formatDate(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0'+minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return (date.getMonth()+1) + "/" + date.getDate() + "/" + date.getFullYear();
  }       
}
